import {animate, state, style, transition, trigger} from "@angular/animations";

export const animationSlideInOut = trigger('slideInOut', [
  state('open', style({
    transform: 'translateY(0%)',
  })),
  state('closed', style({
    transform: 'translateY(100%)',
  })),
  transition('open => closed', [
    animate('0.5s ease')
  ]),
  transition('closed => open', [
    animate('0.5s ease')
  ])
]);
